module.exports = __webpack_public_path__ + "static/media/DVS_Logo22.f4ab9097.png";